if (!customElements.get("faq-accordion")) {
  class FaqAccordion extends HTMLElement {
    constructor() {
      super();

      this.handleToggle =
        this.handleToggle.bind(this);
    }

    connectedCallback() {
      this.items = Array.from(
        this.querySelectorAll("[data-faq-item]")
      );

      this.items.forEach((item) => {
        item.addEventListener(
          "toggle",
          this.handleToggle
        );
      });
    }

    disconnectedCallback() {
      this.items?.forEach((item) => {
        item.removeEventListener(
          "toggle",
          this.handleToggle
        );
      });
    }

    handleToggle(event) {
      const activeItem = event.currentTarget;

      if (
        !activeItem.open ||
        this.dataset.singleOpen !== "true"
      ) {
        return;
      }

      this.items.forEach((item) => {
        if (item !== activeItem) {
          item.open = false;
        }
      });
    }
  }

  customElements.define(
    "faq-accordion",
    FaqAccordion
  );
}